import React from 'react';
import ceo from '../../assets/ceo/ceo.png';

const CompanyPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        <div>
          <h1 className="text-3xl font-bold mb-6">О компании</h1>
          <p className="mb-8">
            Компания "Теплогранд" — надежный оптовой поставщик оборудования для систем теплоснабжения, водоснабжения и газоснабжения. Мы предлагаем качественное оборудование от ведущих производителей, обеспечивая надежность и эффективность инженерных систем.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Наша миссия</h2>
          <p className="mb-6">
            Создавать комфортный микроклимат в любых помещениях, предлагая инновационные решения, высококачественное оборудование и профессиональную поддержку на каждом этапе сотрудничества.
          </p>
        </div>
        
        <div className="flex justify-center items-start">
          <div className="relative">
            <img 
              src={ceo} 
              alt="Генеральный директор Теплогранд" 
              className="rounded-lg shadow-lg max-w-full h-auto"
            />
            <div className="mt-2 text-center text-sm text-gray-600">
              <p className="font-semibold">Давыдов Виктор Борисович</p>
              <p>Генеральный директор</p>
            </div>
          </div>
        </div>
      </div>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Наши преимущества</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-3">Широкий ассортимент</h3>
          <p>
            В нашем каталоге представлен большой выбор оборудования от разных брендов, в различных ценовых категориях и с разными техническими характеристиками. Мы регулярно обновляем ассортимент, чтобы предлагать вам только актуальные и востребованные товары.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-3">Качество и надежность</h3>
          <p>
            Мы работаем только с проверенными производителями и гарантируем высокое качество продукции. Все оборудование сертифицировано и соответствует современным стандартам, что обеспечивает его долговечность и надежную работу.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-3">Выгодные цены</h3>
          <p>
            Благодаря прямому сотрудничеству с производителями и оптовым закупкам мы предлагаем конкурентные цены на всю продукцию. Наши клиенты получают лучшее соотношение цены и качества.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-3">Профессиональный сервис</h3>
          <p>
            Наши специалисты всегда готовы помочь вам с выбором оптимального решения, ответить на все вопросы и предоставить экспертные рекомендации. Мы ценим каждого клиента и предлагаем индивидуальный подход.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-3">Быстрая и удобная доставка</h3>
          <p>
            Мы обеспечиваем оперативную доставку по всей стране. Благодаря сотрудничеству с надежными логистическими партнерами ваш заказ будет доставлен точно в срок и в полной сохранности.
          </p>
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg mt-8">
        <p className="text-lg font-medium text-center">
          Выбирая "Теплогранд", вы получаете качественное и надежное оборудование, выгодные условия и надежного партнера для вашего бизнеса.
        </p>
      </div>
    </div>
  );
};

export default CompanyPage; 